import { Component, OnInit } from '@angular/core';
import { LoadingController, NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { OrderService, OrdersListDto, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-orders-history',
  templateUrl: './orders-history.component.html',
  styleUrls: ['./orders-history.component.scss'],
})
export class OrdersHistoryComponent implements OnInit {
  ordersCompleted: OrdersListDto[] = [];
  textoBuscar = '';
  store: StoreResponseDto = {};
  loading: HTMLIonLoadingElement;

  constructor(
    private authService: AuthService,
    private orderService: OrderService,
    public loadingController: LoadingController,
    private nav: NavController
  ) { }

  async ngOnInit() {
    this.store = this.authService.currentUserStore();
    this.loading = await this.loadingController.create({
      message: 'Cargando...',
    });

    await this.loading.present();
    this.getOrders()
  }

  private async getOrders(event?:any){
    this.orderService.apiOrderGetAllCompletedByStoreGet(this.store.cdStore).subscribe(response => {
      this.ordersCompleted = response;
      this.loading.dismiss()
      if(event)
      event.target.complete()
    },error=>{
      if (error.status == 401) {
        this.nav.navigateForward('/login');
        this.loading.dismiss();

        if (event)
          event.target.complete();
      }
    })
  }
  public async refresh(event: any) {
    await this.getOrders(event);
  }
  buscar(event){
    this.textoBuscar = event.detail.value;
  }
}
